<template>
  <div class="main-box">
    <div class="main-container">
      <router-view />
    </div>
    <div class="main-menu">
      <div class="semblance" />
      <div class="menus">
        <div
          class="menu"
          v-for="(item, i) in menutree"
          v-bind:key="i"
          @click="jumpOrOpen(item, i)"
        >
          <img
            v-if="'icon' in item && item.icon !== ''"
            :src="activeLabel === item.label ? item.aicon : item.icon"
          />
          <span :class="{ active: activeLabel === item.label }">{{
            item.label
          }}</span>
        </div>
      </div>
    </div>
    <tooltip :menuObj="tooltipObj" @feelback="tooltipHide"></tooltip>
  </div>
</template>

<script>
import tooltip from "./tooltip";
export default {
  name: "MasterPlate",
  components: {
    tooltip
  },
  data() {
    return {
      menutree: [
        {
          icon: require("../assets/menuico.png"),
          aicon: require("../assets/menuico-active.png"),
          label: "机场天气",
          child: [
            { label: "自观数据", uri: "/self" },
            { label: "道面数据", uri: "/pavement" },
            { label: "机场预警", uri: "/product", moudel:2},
            { label: "机场警报", uri: "/product", moudel:1},
            { label: "24小时预报", uri: "/product", moudel:3},
            { label: "机场报文", uri: "/message" }
          ]
        },
        {
          icon: require("../assets/menuico.png"),
          aicon: require("../assets/menuico-active.png"),
          label: "区域天气",
          child: [
            { label: "卫星图", uri: "/satellite" },
            { label: "雷达图", uri: "/radar" },
            { label: "天气图", uri: "/weather" }
          ]
        },
        { icon: "", label: "我的账户", uri: "/Home", child: [] }
      ],
      activeLabel: "",
      activeIndex: 0,
      tooltipObj: {
        isShow: false,
        menus: [],
        place: ""
      }
    };
  },
  methods: {
    jumpOrOpen(m, i) {
      if (m.child.length <= 0 && "uri" in m) {
        this.$router.push({
          path: m.uri
        });
      } else if (m.child.length <= 0) {
        return;
      }
      this.activeIndex = i;
      this.activeLabel = m.label;
      this.activeItem = m;
      this.tooltipObj.isShow = !("uri" in this.activeItem);
      this.tooltipObj.menus = this.activeItem.child;
      this.tooltipObj.place = this.activeIndex;
    },
    tooltipHide() {
      this.tooltipObj.place = "";
    }
  },
  mounted() {
    const that = this;
    that.activeItem = that.menutree[that.menutree.length - 1];
    that.activeLabel = that.activeItem.label;
    that.activeIndex = that.menutree.length - 1;
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/styles/index";
.main-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  .main-container {
    height: 92.3%;
    border: 0;
    background-image: linear-gradient(108deg, #32383e 0%, #1d1f23 100%);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
  }
  .main-menu {
    height: 7.7%;
    background-image: linear-gradient(180deg, #262b2f 0%, #1d1f23 100%);
    box-shadow: 0px -3px 21px 0px rgba(0, 0, 0, 0.5);
    .semblance {
      height: 2px;
      width: 100%;
      background: url("../assets/menu-top-line.png") no-repeat center;
      background-size: 100% 100%;
    }
    .menus {
      height: calc(100% - 2px);
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      .menu {
        height: 66.6%;
        width: 33.3%;
        border-left: 1px solid #373e44;
        border-right: 1px solid #373e44;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        img {
          height: 6px;
          width: 6px;
        }
        span {
          font-size: px2rem(14);
          color: #a4a6a8;
          margin-left: 4px;
        }
      }
      > .menu:first-child {
        border-left: 0;
      }
      > .menu:last-child {
        border-right: 0;
      }
    }
  }
  .active {
    color: #e02c00 !important;
  }
}
</style>
